import type { MaterialSymbol } from "material-symbols";
import type { FC, ReactElement } from "react";
import type { Key } from "react-aria";

export interface FixedPanelTabProps {
  id: Key;
  title: string;
  icon: ReactElement | MaterialSymbol;
  position: number;
  children: ReactElement<FixedPanelTabProps>; // The panel system renders itself
}

// FixedPanelTab component - just holds props, renders nothing
export const FixedPanelTab: FC<FixedPanelTabProps> = () => {
  return null; // This component only exists to hold props
};
